import { css } from "styled-components";
import { BladeContent } from "../../../../components/BladeContent";
import { BladeHeader, BladeHeaderBody, BladeHeaderSupertitle, BladeHeaderTitle, } from "../../../../components/BladeHeader";
import { Backdrop, BackdropBackground } from "../../../../components/Backdrop";
import { Icon } from "../../../../components/Icon";
import { textUppercaseMixin } from "../../../../skins/shared/mixins/typography";
export const riotProductSkin = (chroma, palette) => css `
  position: relative;
  min-height: 850px;
  padding: ${chroma.spacers.bladeEdge.top} 0 ${chroma.spacers.bladeEdge.bottom};
  display: flex;
  flex-direction: column;
  background-color: ${palette.bladebg1};

  ${chroma.mediaQueries.tabletDown} {
    padding-top: 0;
  }

  ${Backdrop} {
    ${chroma.mediaQueries.tabletDown} {
      position: relative;
      width: 100%;
      ${BackdropBackground} {
        position: relative;
        height: auto;
      }
    }

    & .backdrop-gradient {
      background: linear-gradient(270deg, rgba(0 0 0 / 0%) 24.44%, rgba(0 0 0 / 60%) 56.63%);
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;

      ${chroma.mediaQueries.tabletDown} {
        background: linear-gradient(0deg, rgba(0 0 0 /70%) 0%, rgba(0 0 0 / 0%) 93%);
      }
    }
  }

  .blade-top-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: ${chroma.spacers.variable.m};
    flex-grow: 1;
    ${chroma.mediaQueries.tabletDown} {
      padding: ${chroma.spacers.variable.l} 0;
      justify-content: flex-start;
    }
  }

  .character-meta-container {
    display: flex;
    gap: ${chroma.spacers.constant.s};

    & .character-meta-box-wrapper {
      border: 1px solid ${palette.accents1};
      padding: ${chroma.spacers.constant.xs};
      min-width: 130px;
      min-height: 130px;

      & .character-meta-box {
        position: relative;
        padding: ${chroma.spacers.constant.xs};
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: ${chroma.spacers.constant.xs};
        flex-grow: 1;

        &::before {
          content: "";
          display: inline-block;
          position: absolute;
          opacity: 0.7;
          background-color: ${palette.underlay};
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
        }

        & .role-icon-wrapper {
          position: relative;
          z-index: 1;
          display: flex;
          align-items: center;
          gap: ${chroma.spacers.constant.xs};
        }

        & ${Icon} {
          background-color: ${palette.accents1};
        }

        & .meta-description {
          position: relative;
          z-index: 1;
          text-align: center;
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: ${chroma.spacers.constant.xs};
          ${textUppercaseMixin};

          & .meta-title {
            color: ${palette.bladetext1};
          }

          & .meta-details {
            color: ${palette.bladetext2};
          }
        }
      }
    }
  }

  .content-footer {
    display: flex;
    width: 100%;
    border-top: 1px solid ${palette.accents1};
    gap: ${chroma.spacers.constant.sm};
    padding: ${chroma.spacers.constant.xs} 0;
    ${chroma.mediaQueries.desktopOnly} {
      max-width: 700px;
    }

    & .character-mastery-link {
      ${textUppercaseMixin};
      color: ${palette.bladetext1};
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }

    & .character-mastery-title {
      color: ${palette.bladetext1_light};
      ${textUppercaseMixin};
    }
  }

  ${BladeContent} {
    position: relative;
    height: 100%;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  ${BladeHeader} {
    display: flex;
    flex-direction: column;
    gap: ${chroma.spacers.variable.s};
    ${chroma.mediaQueries.desktopUp} {
      max-width: 700px;
    }
  }

  ${BladeHeaderBody} {
    ${chroma.typography.body3}
    color: ${palette.bladetext1};
  }

  ${BladeHeaderSupertitle} {
    color: ${palette.bladetext2};
    ${chroma.typography.display6};
    font-style: italic;
    ${textUppercaseMixin};
  }

  ${BladeHeaderTitle} {
    color: ${palette.bladetext1};
    ${chroma.typography.display2};
    font-style: italic;
    ${textUppercaseMixin};
    line-height: 1;
  }
`;
//# sourceMappingURL=index.js.map